import { isObject } from '../object/is-object';
import { DateRange } from './date-range';

export function isDateRange(predictable: unknown): predictable is DateRange {
  if (!isObject(predictable)) {
    return false;
  }

  return (
    'from' in predictable &&
    'to' in predictable &&
    predictable.from instanceof Date &&
    predictable.to instanceof Date
  );
}
